
import type {
  BaseErrorResponse,
  EmptySuccessResponse,
  GetDeliveriesRes,
  GetDeliveryConfiguration,
  GetDeliveryOptionPriceReq,
  GetDeliveryOptionPriceRes,
  GetDeliveryOptionsReq,
  GetDeliveryOptionsRes,
  SetDeliveryConfigurationReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useDelivery() {
  class Delivery<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Delivery
     * @name DeliveryControllerGetDeliveries
     * @summary Returns all delivery handlers
     * @request GET:/api3/delivery
     * @secure
     * @response `200` `GetDeliveriesRes`
     * @response `400` `BaseErrorResponse`
     */
    deliveryControllerGetDeliveries = (params: RequestParams = {}) =>
      this.request<GetDeliveriesRes, BaseErrorResponse>({
        path: '/api3/delivery',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Delivery
     * @name DeliveryControllerGetDeliveryOptions
     * @summary Returns delivery options for the specified delivery method
     * @request POST:/api3/delivery/{alias}/options
     * @secure
     * @response `200` `GetDeliveryOptionsRes`
     * @response `400` `BaseErrorResponse`
     */
    deliveryControllerGetDeliveryOptions = (alias: string, data: GetDeliveryOptionsReq, params: RequestParams = {}) =>
      this.request<GetDeliveryOptionsRes, BaseErrorResponse>({
        path: `/api3/delivery/${alias}/options`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Delivery
     * @name DeliveryControllerGetDeliveryOptionPrice
     * @summary Returns price for delivery options
     * @request POST:/api3/delivery/{alias}/price
     * @secure
     * @response `200` `GetDeliveryOptionPriceRes`
     * @response `400` `BaseErrorResponse`
     */
    deliveryControllerGetDeliveryOptionPrice = (
      alias: string,
      data: GetDeliveryOptionPriceReq,
      params: RequestParams = {},
    ) =>
      this.request<GetDeliveryOptionPriceRes, BaseErrorResponse>({
        path: `/api3/delivery/${alias}/price`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Delivery
     * @name DeliveryControllerSetConfiguration
     * @summary Sets delivery configuration
     * @request PUT:/api3/delivery/{alias}/config
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    deliveryControllerSetConfiguration = (
      alias: string,
      data: SetDeliveryConfigurationReq,
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/delivery/${alias}/config`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Delivery
     * @name DeliveryControllerGetConfiguration
     * @summary Returns delivery configuration
     * @request GET:/api3/delivery/{alias}/config
     * @secure
     * @response `200` `GetDeliveryConfiguration`
     * @response `400` `BaseErrorResponse`
     */
    deliveryControllerGetConfiguration = (alias: string, params: RequestParams = {}) =>
      this.request<GetDeliveryConfiguration, BaseErrorResponse>({
        path: `/api3/delivery/${alias}/config`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Delivery();
}
